import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../lib/api";
import { Verified, Crown, Building2, Globe2, ArrowRight } from "lucide-react";

export default function ExchangeMemberProfile() {
  const { handle } = useParams();
  const [m, setM] = useState(null);
  const [listings, setListings] = useState([]);

  useEffect(() => {
    api.get(`/exchange/members/${handle}`).then(r => setM(r.data)).catch(() => setM(null));
    api.get("/exchange/listings", { params: { limit: 50 } }).then(r => setListings(r.data));
  }, [handle]);

  if (!m) return <div className="max-w-7xl mx-auto px-6 py-20" data-testid="member-loading">Loading…</div>;
  const myListings = listings.filter(l => l.posted_by_profile?.handle === handle);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12" data-testid="member-profile">
      <Link to="/exchange/members" className="mono text-[11px] tracking-[0.22em] uppercase text-[#D97706] hover:underline">← All Members</Link>

      <div className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-10">
        <div className="lg:col-span-1">
          <div className="border border-gray-300 p-7 bg-gray-50">
            <div className="w-20 h-20 text-white flex items-center justify-center font-bold text-2xl"
              style={{ background: `hsl(${(m.avatar_seed || m.name).charCodeAt(0) * 5 % 360}, 35%, 22%)` }}>
              {m.name.split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase()}
            </div>
            <h1 className="display-black text-2xl uppercase text-[#064E3B] mt-5 flex items-center gap-2">
              {m.name}
              {m.verified && <Verified className="w-5 h-5 text-[#064E3B]" />}
              {m.premium && <Crown className="w-5 h-5 text-[#FACC15]" />}
            </h1>
            <div className="text-sm text-gray-800 mt-1">{m.title}</div>
            <div className="mono text-[11px] tracking-wider text-gray-500 uppercase mt-3 space-y-1">
              <div className="flex items-center gap-2"><Building2 className="w-3 h-3" /> {m.company}</div>
              <div className="flex items-center gap-2"><Globe2 className="w-3 h-3" /> {m.location}</div>
            </div>
            <p className="text-sm text-gray-800 mt-5">{m.bio}</p>
            <div className="grid grid-cols-2 gap-px bg-gray-300 border border-gray-300 mt-6">
              <div className="bg-white p-3 text-center">
                <div className="display-black text-xl text-[#064E3B]">{m.deals_closed}</div>
                <div className="mono text-[10px] tracking-wider text-gray-500 uppercase mt-1">Closed</div>
              </div>
              <div className="bg-white p-3 text-center">
                <div className="display-black text-xl text-[#D97706]">${m.deal_volume_m}M</div>
                <div className="mono text-[10px] tracking-wider text-gray-500 uppercase mt-1">Volume</div>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-2">
          <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#D97706]">// Active Listings by {m.name.split(" ")[0]}</div>
          <h2 className="display-black text-3xl uppercase text-[#064E3B] mt-2">{myListings.length} active deals.</h2>
          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-px bg-gray-300 border border-gray-300">
            {myListings.map(l => (
              <Link key={l.id} to={`/exchange/listing/${l.id}`} className="bento-card p-6" data-testid={`member-listing-${l.id}`}>
                <div className="mono text-[10px] tracking-[0.22em] uppercase text-[#D97706]">{l.type} · {l.size} · {l.region}</div>
                <h3 className="display-black text-lg uppercase text-[#064E3B] mt-2">{l.title}</h3>
                <div className="mono text-[11px] tracking-wider text-gray-500 uppercase mt-3 flex items-center gap-2">
                  ${l.deal_value_m}M <ArrowRight className="w-3 h-3" />
                </div>
              </Link>
            ))}
            {myListings.length === 0 && <div className="bg-white p-8 md:col-span-2 text-sm text-gray-500">No active listings.</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
